import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError } from 'rxjs';
import { CommonService } from './common-service';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class UtilService extends CommonService {
  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    super();
  }

  public getIP(): Observable<IPReturn> {
    return this.httpClient
      .get<IPReturn>('https://api.ipify.org/?format=json')
      .pipe(catchError(this.handleError));
  }

  public getAddressByCEP(cep: string): Observable<CEPCorreios> {
    return this.httpClient
      .get<CEPCorreios>('https://viacep.com.br/ws/' + cep + '/json/')
      .pipe(catchError(this.handleError));
  }

  public createSlug(texto: string): string {
    return texto
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Remove acentos
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')   // CORRIGIDO: Agora inclui o intervalo de 0 a 9
      .replace(/\s+/g, '-')           // Espaços viram hífens
      .replace(/-+/g, '-')           // Remove hífens duplicados
      .replace(/^-+|-+$/g, '');       // Remove hífens do início ou do fim (limpeza extra)
  }
}

export class IPReturn {
  public ip: string;
}

export class CEPCorreios {
  public cep: string;
  public logradouro: string;
  public complemento: string;
  public bairro: string;
  public localidade: string;
  public uf: string;
  public ibge: string;
}
